<template>
	<b-row>
		<b-col cols="12">
			<b-card>
				<div slot="header">
					{{ $t(`${section}.title`) }}
					<div class="card-header-actions">
						<!--						<b-link v-if="isKirim && isAdmin"-->
						<!--								@click="openSidebarPricing"-->
						<!--								class="pr-2"-->
						<!--						>-->
						<!--							<i class="fa fa-plus-circle" style="font-size: 15px"></i>-->
						<!--							<span class="pl-1">{{ $t('warehouse.document.changeIncomePrice') }}</span>-->
						<!--						</b-link>-->
						<b-link @click="openCreate('create')"
								class="card-header-action btn-setting"
								style="font-size: 15px"
								v-if="$can('create', 'warehouse-document')"
						>
							<i class="fa fa-plus-circle"></i>
						</b-link>
						<vs-dropdown vs-custom-content vs-trigger-click>
							<b-link href.prevent class="card-header-action btn-setting" style="font-size: 15px">
								<i class="fa fa-th"></i>
							</b-link>
							<vs-dropdown-menu class="columns-dropdown">
								<visible-columns :default-fields="columns" @result="columnListener"></visible-columns>
							</vs-dropdown-menu>
						</vs-dropdown>

						<b-link @click="toggle.filter = !toggle.filter" class="card-header-action btn-setting"
								style="font-size: 15px">
							<i class="fa fa-search"></i>
						</b-link>
					</div>
				</div>
				<vs-sidebar
					position-right
					parent="body"
					default-index="1"
					color="primary"
					class="create-modal priceSidebar"
					spacer
					v-model="activeSidebar"
					:click-not-close="true"
				>
					<add-pricing @closeSidebar="closeSidebar"
								 :isSidebarOpen="activeSidebar"></add-pricing>
				</vs-sidebar>
				<b-card-body>
					<b-collapse v-model="toggle.filter" id="filterColumns">
						<filter-items
							ref="filterRef"
							@filtered="filterItems"
							:section="sectionName"
						></filter-items>
					</b-collapse>
					<!-- TRANSFER TABS START -->
					<b-tabs @input="changed" v-if="isTransfer" v-model="customTabIndex" justified>
						<b-tab :title="`Черновик` + (customTabIndex===0?` (${total})`:'')" :key="0">
							<div class="table-wrapper">
								<b-table
									class="generalTableClass mb-2 poin"
									:items="items"
									:fields="fields"
									hover="hover"
									striped="striped"
									bordered="bordered"
									tbody-tr-class="hov"
									responsive
									show-empty
									@row-clicked="rowClick"
								>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty') }}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->

									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }} </strong>
									</template>

									<template slot="regNumber" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="reason" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="comment" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="regDate" slot-scope="data">
										{{ formatDate(data.value) }}
									</template>
									<template slot="actions" slot-scope="data">
										<div class="text-dark">
											<b-link :to="'/warehouse-management/transfers/view/' + data.item.id" class="mr-2">
												<i class="fa fa-eye" style="font-size: 18px"></i>
											</b-link>
											<b-link v-if="$can('edit', 'warehouse-document') && data.item.documentStatus=='SUSPENDED'" @click="edit(data.item)" class="mr-2">
												<i class="fa fa-edit" style="font-size: 18px"></i>
											</b-link>
											<b-link :to="`/warehouse-management/transfers/prices-generate/${data.item.id}/${data.item.toDepartmentName}`" class="mr-2">
												<i class="fa fa-money" style="font-size: 18px"></i>
											</b-link>
											<b-link
												v-if="data.item.documentStatus=='SUSPENDED' && $can('delete', 'warehouse-document')"
												:key="data.item.id + 'delete'"
												:id="'popOverDelete'+data.item.id"
												@click="showConfirm(data.item.id)" class="mr-2"
											>
												<i class="fa fa-trash" style="font-size: 18px"></i>
											</b-link>
											<b-popover
												:key="data.item.id + 'popover'"
												:target="'popOverDelete'+data.item.id"
												placement="left"
												:ref="'popover'+data.item.id"
												class="refDeleteConfirm"
											>
												<template slot="title">
													<b-button @click="closeConfirm(data.item.id)" class="close"
															  aria-label="Close" style="margin-left: 5px">
														<span class="d-inline-block" aria-hidden="true">&times;</span>
													</b-button>
													{{ $t('want_to_delete?') }}
												</template>

												<div>
													<div class="row mt-1">
														<div class="col-6">
															<b-button variant="outline-danger" size="sm" block
																	  @click="closeConfirm(data.item.id)"> {{
																	$t('No')
																}}
															</b-button>
														</div>
														<div class="col-6">
															<b-button variant="outline-success" size="sm" block
																	  @click="removeForTransfer(data.item.id,customTabIndex)">
																{{ $t('Yes') }}
															</b-button>
														</div>
													</div>
												</div>
											</b-popover>
										</div>
									</template>
								</b-table>
								<nav class="text-center">
									<b-pagination-new
										background
										:total="total"
										layout="prev, pager, next"
										:page-size="search.limit"
										:current-page.sync="search.page"
										@current-change="updateList($event, activeTab)"/>
								</nav>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</b-tab>
						<b-tab :title="`Подтверждение` + (customTabIndex===1?` (${total})`:'')" :key="1">
							<div class="table-wrapper">
								<b-table
									class="generalTableClass mb-2 poin"
									:items="items"
									:fields="fields"
									hover="hover"
									striped="striped"
									bordered="bordered"
									tbody-tr-class="hov"
									responsive
									show-empty
									@row-clicked="rowClick"
								>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty') }}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }} </strong>
									</template>
									<template slot="regNumber" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="reason" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="comment" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="regDate" slot-scope="data">
										{{ formatDate(data.value) }}
									</template>
									<template slot="actions" slot-scope="data">
										<div class="text-dark">
											<b-link :to="'/warehouse-management/transfers/view/' + data.item.id" class="mr-2">
												<i class="fa fa-eye" style="font-size: 18px"></i>
											</b-link>
											<b-link v-if="$can('edit', 'warehouse-document')&&$can('transfer', 'saveAndFinish')" @click="edit(data.item)" class="mr-2">
												<i class="fa fa-edit" style="font-size: 18px"></i>
											</b-link>
										</div>
									</template>
								</b-table>
								<nav class="text-center">
									<b-pagination-new
										background
										:total="total"
										layout="prev, pager, next"
										:page-size="search.limit"
										:current-page.sync="search.page"
										@current-change="updateList($event, activeTab)"/>
								</nav>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</b-tab>
						<b-tab :title="$t('warehouse.item.send') + (customTabIndex===2?` (${total})`:'')" :key="2">
							<b-modal
								hide-footer
								v-model="modalAviz">
								<b-row>
									<b-col cols="4" class="pt-1">
										Descriere
									</b-col>
									<b-col cols="8">
										<multiselect
											class="pt-1"
											:placeholder="$t('users-l.create.employee')"
											v-model="value"
											:custom-label="userSelectedOption"
											:options="options">
										</multiselect>
									</b-col>
									<br>
									<br>
									<b-col cols="4" class="pt-1">
										Tip document
									</b-col>
									<b-col cols="8">
										<b-input :disabled="true" value="Aviz"></b-input>
									</b-col>
									<br>
									<br>
									<b-col cols="4" class="pt-1">
										Denimure serie
									</b-col>
									<b-col cols="8">
										<b-input v-model="name"></b-input>
									</b-col>
									<br>
									<br>
									<b-col cols="4" class="pt-1">
										Primal numar
									</b-col>
									<b-col cols="8">
										<b-input v-model="regNumberAviz"></b-input>
									</b-col>
								</b-row>
								<b-row class="mt-3">
									<b-col cols="6"></b-col>
									<b-col cols="3" class="text-right">

										<!-- <b-button variant="danger" @click="closeAvizModal">
											{{$t('cancel')}}
										</b-button> -->
									</b-col>
									<b-col cols="3" class="text-right">
										<b-button @click="createAvizDocForUser" variant="success">
											{{ $t('save') }}
										</b-button>
									</b-col>
								</b-row>
							</b-modal>
							<div class="table-wrapper">
								<b-table
									class="generalTableClass mb-2 poin"
									:items="items"
									:fields="fields"
									hover="hover"
									striped="striped"
									bordered="bordered"
									tbody-tr-class="hov"
									responsive
									show-empty
									@row-clicked="rowClick"
								>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty') }}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->

									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }} </strong>
									</template>

									<template slot="regNumber" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="reason" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="comment" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="regDate" slot-scope="data">
										{{ formatDate(data.value) }}
									</template>
									<template slot="actions" slot-scope="data">
										<div class="text-dark">
											<b-link :to="'/warehouse-management/transfers/view/' + data.item.id" class="mr-2">
												<i class="fa fa-eye" style="font-size: 18px"></i>
											</b-link>
											<b-link @click="copyDoc(data.item.id)" class="mr-2">
												<i class="fa fa-copy" style="font-size: 18px"></i>
											</b-link>
											<b-link :to="`/warehouse-management/transfers/prices-generate/${data.item.id}/${data.item.toDepartmentName}`" class="mr-2">
												<i class="fa fa-money" style="font-size: 18px"></i>
											</b-link>
										</div>
									</template>
								</b-table>
								<nav class="text-center">
									<b-pagination-new
										background
										:total="total"
										layout="prev, pager, next"
										:page-size="search.limit"
										:current-page.sync="search.page"
										@current-change="updateList($event, activeTab)"/>
								</nav>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</b-tab>
						<b-tab :title="$t('pending.send') + (customTabIndex===3?` (${total})`:'')" :key="3">
							<div class="table-wrapper table-responsive">
								<b-table
									class="generalTableClass mb-2 poin"
									:items="items"
									:fields="fields"
									hover="hover"
									striped="striped"
									bordered="bordered"
									tbody-tr-class="hov"
									responsive
									show-empty
									@row-clicked="rowClick"
								>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty') }}</h4>
									</template>
									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }}</strong>
									</template>
									<template slot="regNumber" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="reason" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="comment" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="regDate" slot-scope="data">
										{{ formatDate(data.value) }}
									</template>
									<template slot="actions" slot-scope="data">
										<div class="text-dark">
											<b-link :to="'/warehouse-management/transfers/view/' + data.item.id" class="mr-2">
												<i class="fa fa-eye" style="font-size: 20px"></i>
											</b-link>
											<b-link v-if="data.item.editable && $can('edit', 'warehouse-document')" @click="edit(data.item)" class="mr-2">
												<i class="fa fa-edit"></i>
											</b-link>
											<b-link :to="`/warehouse-management/transfers/prices-generate/${data.item.id}/${data.item.toDepartmentName}`">
												<i class="fa fa-money" style="font-size: 20px"></i>
											</b-link>
										</div>
									</template>
								</b-table>
								<nav class="text-center">
									<b-pagination-new
										background
										:total="total"
										layout="prev, pager, next"
										:page-size="search.limit"
										:current-page.sync="search.page"
										@current-change="updateList($event, activeTab)"/>
								</nav>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</b-tab>
						<b-tab :title="$t('incomes.pending') + ` (${pending.total})`" :key="4">
							<div class="table-wrapper">
								<b-table
									class="generalTableClass mb-2 poin"
									:items="pending.items"
									:fields="fields"
									hover="hover"
									striped="striped"
									bordered="bordered"
									responsive
									show-empty
									@row-clicked="rowClick"
								>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope" >
										<h4>{{ $t('empty') }}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->

									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }}</strong>
									</template>

									<template slot="regNumber" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="reason" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="comment" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="regDate" slot-scope="data">
										{{ formatDate(data.value) }}
									</template>
									<template slot="actions" slot-scope="data">
										<div class="text-dark">
											<b-link :to="'/warehouse-management/transfers/view/' + data.item.id" class="mr-2">
												<i class="fa fa-eye" style="font-size: 18px"></i>
											</b-link>
											<b-link :to="'/warehouse-management/income/pending/' + data.item.id">
												<i class="fa fa-edit" style="font-size: 18px"></i>
											</b-link>
										</div>
									</template>
								</b-table>
								<nav class="text-center">
									<b-pagination-new
										background
										:total="total"
										layout="prev, pager, next"
										:page-size="search.limit"
										:current-page.sync="search.page"
										@current-change="updateList($event, activeTab)"/>
								</nav>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</b-tab>
					</b-tabs>
					<!-- WRITEOFF TABS START -->
					<b-tabs @input="changed" v-if="isOff" justified>
						<b-tab :title="$t('incomes.active') + ` (${total})`" active>
							<div class="table-wrapper">
								<b-table
									class="generalTableClass mb-2"
									:items="items"
									:fields="fields"
									hover="hover"
									striped="striped"
									bordered="bordered"
									responsive
									show-empty
									@row-clicked="rowClick2"
								>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty') }}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->

									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }}</strong>
									</template>

									<template slot="regNumber" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="reason" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="comment" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="regDate" slot-scope="data">
										{{ formatDate(data.value) }}
									</template>
									<template slot="actions" slot-scope="data">
										<div class="text-dark">
											<b-link :to="'/warehouse-management/writeOff/view/' + data.item.id" v-if="section=='spisat'" class="mr-2">
												<i class="fa fa-eye" style="font-size: 18px"></i>
											</b-link>
											<b-link v-if="data.item.documentStatus=='SUSPENDED' && $can('edit', 'warehouse-document')" @click="edit(data.item)" class="mr-2">
												<i class="fa fa-edit" style="font-size: 18px"></i>
											</b-link>
											<b-link
												v-if="data.item.documentStatus=='SUSPENDED' && $can('delete', 'warehouse-document')"
												:key="data.item.id + 'delete'"
												:id="'popOverDelete'+data.item.id"
												@click="showConfirm(data.item.id)"
											>
												<i class="fa fa-trash" style="font-size: 18px"></i>
											</b-link>
											<b-popover
												:key="data.item.id + 'popover'"
												:target="'popOverDelete'+data.item.id"
												placement="left"
												:ref="'popover'+data.item.id"
												class="refDeleteConfirm"
											>
												<template slot="title">
													<b-button @click="closeConfirm(data.item.id)" class="close"
															  aria-label="Close" style="margin-left: 5px">
														<span class="d-inline-block" aria-hidden="true">&times;</span>
													</b-button>
													{{ $t('want_to_delete?') }}
												</template>
												<div>
													<div class="row mt-1">
														<div class="col-6">
															<b-button variant="outline-danger" size="sm" block
																	  @click="closeConfirm(data.item.id)">
																{{ $t('No') }}</b-button>
														</div>
														<div class="col-6">
															<b-button variant="outline-success" size="sm" block
																	  @click="removeForSpisat(data.item.id)">{{ $t('Yes') }}
															</b-button>
														</div>
													</div>
												</div>
											</b-popover>
										</div>

									</template>
								</b-table>
								<nav class="text-center">
									<b-pagination-new
										background
										:total="total"
										layout="prev, pager, next"
										:page-size="search.limit"
										:current-page.sync="search.page"
										@current-change="updateList($event, activeTab)"/>
								</nav>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</b-tab>
					</b-tabs>
					<!-- INCOME TABS START -->
					<b-tabs v-if="isKirim" @input="changed($event, 'forPendingIncome')" justified>
						<b-tab :title="$t('incomes.active') + ` (${total})`" active>
							<div class="table-wrapper">
								<b-table class="generalTableClass mb-2 poin" id="incomeTable" :items="items" :fields="fields" hover="hover"  striped="striped" bordered="bordered" responsive show-empty @row-clicked="rowClickprixod">
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty') }}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="id" slot-scope="data">
										<strong>{{ paginate(data.index, search.page, search.limit) }}</strong>
									</template>
									<template slot="documentStatus" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="regNumber" slot-scope="data">
										{{ data.value }}
									</template>
									<template slot="reason" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="comment" slot-scope="data">
										<div class="no-wrap">
											{{ data.value }}
										</div>
									</template>
									<template slot="regDate" slot-scope="data">
										{{ formatDate(data.value) }}
									</template>
									<template slot="actions" slot-scope="data">
										<div class="text-dark">
											<b-link v-if="data.item.documentStatus != 'IN_AKT'" :to="`/warehouse-management/income-view/view/${data.item.id}`" class="mr-2">
												<i class="fa fa-eye" style="font-size: 18px"/>
											</b-link>
											<b-link v-if="data.item.documentStatus === 'ADD_EXTRA_COST' && data.item.extraCosts == undefined" @click="addExtraCost(data.item)" class="mr-2">
												<i class="fa fa-plus-circle text-primary" style="font-size: 18px"/>
											</b-link>
											<b-link v-if="data.item.documentStatus == 'IN_AKT'" :to="'/warehouse-management/income/act/view/' + data.item.id" class="mr-2">
												<i class="fa fa-eye" style="font-size: 18px"/>
											</b-link>
											<b-link v-if="data.item.documentStatus == 'WAITING_IMPROVABLE' && data.item.extraCosts == undefined" class="mr-2" :to="`/warehouse-management/income-view/checking/${data.item.id}`">
												<i class="fa fa-check" style="font-size: 18px"/>
											</b-link>
											<b-link v-if="data.item.documentStatus=='RECOUNT'" @click="edit(data.item)" class="mr-2">
												<i class="fa fa-edit" style="font-size: 18px"/>
											</b-link>
											<b-link v-if="data.item.documentStatus=='SUSPENDED'" @click="edit(data.item)" class="mr-2">
												<i class="fa fa-edit" style="font-size: 18px"/>
											</b-link>
											<b-link v-if="data.item.documentStatus!=='READY' && $can('delete', 'warehouse-document')" :key="data.item.id + 'delete'" :id="'popOverDelete'+data.item.id" @click="showConfirm(data.item.id)" class="mr-2">
												<i class="fa fa-trash" style="font-size: 18px"/>
											</b-link>
											<b-link v-if="data.item.documentStatus=='ADDED_EXTRA_COSTS'" :to="'/warehouse-management/income/pricing/' + data.item.id">
												<i class="fa fa-money" style="font-size: 18px"/>
											</b-link>
											<b-popover :key="data.item.id + 'popover'"
													   :target="'popOverDelete'+data.item.id" placement="left"
													   :ref="'popover'+data.item.id" class="refDeleteConfirm">
												<template slot="title">
													<b-button @click="closeConfirm(data.item.id)" class="close"
															  aria-label="Close" style="margin-left: 5px">
														<span class="d-inline-block" aria-hidden="true">&times;</span>
													</b-button>
													{{ $t('want_to_delete?') }}
												</template>

												<div>
													<div class="row mt-1">
														<div class="col-6">
															<b-button variant="outline-danger" size="sm" block @click="closeConfirm(data.item.id)"> {{$t('actions.no') }}</b-button>
														</div>
														<div class="col-6">
															<b-button variant="outline-success" size="sm" block @click="remove(data.item.id)">{{$t('actions.yes') }}</b-button>
														</div>
													</div>
												</div>
											</b-popover>
										</div>
									</template>
								</b-table>
								<nav class="text-center">
									<b-pagination-new
										background
										:total="total"
										layout="prev, pager, next"
										:page-size="search.limit"
										:current-page.sync="search.page"
										@current-change="updateList($event, activeTab)"/>
								</nav>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</b-tab>
						<b-tab title="Aкт" @click="getAktList">
							<div class="table-wrapper">
								<table class="table table-hover table-bordered table-striped mt-3 poin" id="table" @row-clicked="editAkt(item.id, 'view')">
									<thead>
									<tr>
										<th class="text-center">№</th>
										<th class="text-center">{{ $t('incomes.name') }}</th>
										<th class="text-center">{{ $t('incomes.date') }}</th>
										<th class="text-center">{{ $t('incomes.counteragent') }}</th>
										<th class="text-center">{{ $t('sale.status') }}</th>
										<th class="text-center" style="width: 10%">{{ $t('prices.item.actions') }}</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(item, index) in aktList.items">
										<td class="text-center">{{
												paginate(index, aktPayload.page, aktPayload.limit)
											}}
										</td>
										<td class="text-center">{{ item.regNumber }}</td>
										<td class="text-center">{{ item.regDate }}</td>
										<td class="text-center">
											<p v-for="user in item.userAndWhDocuments">
												{{ user.employeeName }} -
												<span v-if="user.status == 'APPROVED'"><i
													class="fa fa-check text-success"></i></span>
												<span v-else-if="user.status == 'REJECTED'"><i
													class="fa fa-close text-danger"></i></span>
												<span v-else>...</span>
											</p>
										</td>
										<td class="text-center">{{ item.documentStatus }}</td>
										<td class="text-center">
											<b-link v-if="item.documentStatus == 'SUSPENDED' && !item.hasUserApproved"
													@click="editAkt(item.id, 'edit')">
												<i class="fa fa-edit mr-2"></i>
											</b-link>
											<b-link v-else-if="item.hasUserApproved" @click="editAkt(item.id, 'view')">
												<i class="fa fa-eye"></i>
											</b-link>
											<b-link v-else-if="item.documentStatus == 'READY'"
													@click="editAkt(item.id, 'view')">
												<i class="fa fa-eye"></i>
											</b-link>
										</td>
									</tr>
									</tbody>
								</table>
								<nav>
									<b-pagination :total-rows="aktList.total"
												  :per-page="aktPayload.limit"
												  v-model="aktPayload.page"
												  aria-controls="table"/>
								</nav>
							</div>
						</b-tab>
					</b-tabs>
					<div v-if="isChiqim" class="table-wrapper">
						<b-table class="generalTableClass mb-2" :items="items"
								 :fields="fields" hover="hover" striped="striped" bordered="bordered"
								 responsive show-empty>
							<!-- EMPTY SLOT FOR TABLE -->
							<template slot="empty" slot-scope="scope">
								<h4>{{ $t('empty') }}</h4>
							</template>
							<!-- EMPTY SLOT FOR TABLE -->

							<template slot="id" slot-scope="data">
								<strong>{{ paginate(data.index, search.page, search.limit) }}</strong>
							</template>

							<template slot="regNumber" slot-scope="data">
								{{ data.value }}
							</template>
							<template slot="reason" slot-scope="data">
								<div class="no-wrap">
									{{ data.value }}
								</div>
							</template>
							<template slot="comment" slot-scope="data">
								<div class="no-wrap">
									{{ data.value }}
								</div>
							</template>
							<template slot="regDate" slot-scope="data">
								{{ formatDate(data.value) }}
							</template>
							<template slot="actions" slot-scope="data">
								<div>
									<b-link :to="'/warehouse-management/income/view/' + data.item.id" class="mr-2">
										<i class="fa fa-eye"></i>
									</b-link>
									<b-link v-if="data.item.editable && $can('edit', 'warehouse-document')"
											@click="edit(data.item)">
										<i class="fa fa-edit"></i>
									</b-link>

									<!--<b-link v-if="data.item.editable && $can('delete', 'warehouse-document')"
												:key="data.item.id + 'delete'"
												:id="'popOverDelete'+data.item.id"
												@click="showConfirm(data.item.id)"
										>
											<i class="fa fa-trash"></i>
										</b-link>
										<b-popover
											:key="data.item.id + 'popover'"
											:target="'popOverDelete'+data.item.id"
											placement="left"
											:ref="'popover'+data.item.id"
											class="refDeleteConfirm"
										>
											<template slot="title">
												<b-button @click="closeConfirm(data.item.id)" class="close"
														  aria-label="Close" style="margin-left: 5px">
													<span class="d-inline-block" aria-hidden="true">&times;</span>
												</b-button>
												{{ $t('want_to_delete?') }}
											</template>

											<div>
												<div class="row mt-1">
													<div class="col-6">
														<b-button variant="outline-danger" size="sm" block
																  @click="closeConfirm(data.item.id)"> {{ $t('No')
															}}
														</b-button>
													</div>
													<div class="col-6">
														<b-button variant="outline-success" size="sm" block
																  @click="remove(data.item.id)">{{ $t('Yes') }}
														</b-button>
													</div>
												</div>
											</div>
										</b-popover>-->
								</div>

							</template>
						</b-table>
						<nav>
							<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
										  :prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')"
										  hide-goto-end-buttons/>
						</nav>
						<div v-if="loader" class="spinner-wrapper">
							<b-spinner variant="primary"></b-spinner>
						</div>
					</div>
				</b-card-body>
			</b-card>
		</b-col>
		<vs-sidebar :click-not-close="true"
					position-right
					parent="body"
					default-index="1"
					color="primary"
					class="create-modal-wh"
					spacer
					v-model="sidebar.open">
			<b-container index="1" v-if="sidebar.open">
				<create-form
					@close="close()"
					:mode="sidebar.mode"
					:edit-item="editItem"
					:section="sectionName"
					:copyDocId="copyDocId"
					@redirect="redirect"
					@docSuspended="changed(0, 'forIncome')"
				></create-form>
			</b-container>
		</vs-sidebar>

		<!--		ExtraCost		-->
		<vs-sidebar v-model="sidebarExtraCost" :click-not-close="true" position-right
					parent="body" default-index="2" color="primary" class="create-modal" spacer>
			<b-container v-if="sidebarExtraCost">
				<cost-form
					:document="documentExtraCost"
					@close="closeSidebarExtraCost"
					@saved="savedExtraCost"
				></cost-form>
			</b-container>
		</vs-sidebar>
	</b-row>
</template>

<script>
import IncomesFromSale from './income/components/IncomesFromSale';
import CreateForm from "./blocks/CreateForm";
import Income from "./mixins/Income";
import VisibleColumns from "../goods/blocks/VisibleColumns";
import FilterItems from "./blocks/filterItems";
import WhDocument from "../../../services/wh-document.service";
import Verify from "../../../services/verify.service";
import AddPricing from "./addPricing";
import {mapActions, mapGetters, mapState} from "vuex";
import Multiselect from 'vue-multiselect'
import EmployeeSerive from '../../../services/employees.service';
import {Transfers} from "../extra-cost/mixins/Transfer";
import CostForm from "../extra-cost/blocks/CostForm";
import { Pagination } from 'element-ui'
import ContractService from "../../contract-management/contract.service";
const initialForEditItem = {

	id: null,
	comment: null,
	action: 'KIRIM',
	documentType: 'NAKLADNOY',
	fromDepartmentId: null,
	fromDepartmentName: null,
	toDepartmentId: null,
	toDepartmentName: null,
	fromEmployeeId: null,
	fromEmployeeName: null,
	toEmployeeId: null,
	toEmployeeName: '',
	responsible1Id: null,
	responsible1Name: '',
	responsible2Id: null,
	responsible2Name: '',
	regNumber: '',
	regDate: null,
	contragentId: null,
	contragentName: '',
	reason: null,
	initiatorId: null,
	fromCurrencyRate: null,
	currencyId: null,
	toCurrencyRate: null,
	whItems: []
}
export default {
	name: 'List',
	mixins: [Income, Transfers],
	components: {
		Multiselect,
		AddPricing,
		FilterItems,
		CreateForm,
		VisibleColumns,
		IncomesFromSale,
		CostForm,
		"b-pagination-new":Pagination
	},
	data() {
		return {
			aktList: {},
			aktPayload: {
				page: 1,
				limit: 20
			},
			regNumberAviz: null,
			copyDocId: null,
			docId: null,
			value: null,
			options: [],
			modalAviz: false,
			sidebarExtraCost: false,
			documentExtraCost: null,
			currentDate: new Date().toISOString().slice(0, 10),
			activeSidebar: false,
			customTabIndex: this.$route.query.tab ? Number(this.$route.query.tab) : 0,
			attributes: [{
				field: "documentStatus",
				orderBy: "desc"
			},
				{
					field: "changed",
					orderBy: "desc"
				}
			],
			bTabls: 'Transfer',
			sidebar: {
				open: false,
				close: false,
				mode: 'create'
			},
			toggle: {
				filter: false
			},
			editItem: Object.assign({}, initialForEditItem),
			pending: {
				items: [],
				loaded: false,
				total: 0
			},
			activeTab: this.$route.query.tab ? Number(this.$route.query.tab) : 0,
			tabChanged: false,
		}
	},
	methods: {
		rowClick($event) {
			this.$router.push(`/warehouse-management/transfers/view/${$event.id}`)
		},
		rowClickprixod($event) {
			this.$router.push(`/warehouse-management/income-view/view/${$event.id}`)
		},
		rowClick2($event) {
			this.$router.push(`/warehouse-management/writeOff/view/${$event.id}`)
		},
		addExtraCost(doc) {
			this.documentExtraCost = doc
			this.sidebarExtraCost = true
		},
		closeSidebarExtraCost() {
			setTimeout(() => {
				this.loadIncomes();
				this.loadTransfers();
			}, 200);
			this.sidebarExtraCost = false;
		},
		savedExtraCost() {
			this.closeSidebarExtraCost()
		},
		async getAktList() {
			await WhDocument.getAktListWithSearch(this.aktPayload).then(res => {
				this.aktList = res.data
			})
		},
		editAkt(id, action) {
			this.$router.push(`/warehouse-management/income/act/${action}/${id}`)
		},
		async createAvizDocForUser() {
			try {
				let payload = {
					whDocumentId: this.docId,
					responsibleId: this.value.id,
					regNumber: this.regNumberAviz,
					initialLetter: this.name
				}
				let res = await EmployeeSerive.createAviz(payload)
				if (res.data) {
					await this.$router.push('/warehouse-management/transfers/view-aviz/' + this.docId)
				}
			} catch (e) {
				if (e.request.response) {
					let res = JSON.parse(e.request.response)
					this.$vs.notify({
						title: this.$t('words.error'),
						text: res.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
			}
		},
		userSelectedOption(user) {
			return user.firstName + ' ' + user.lastName;
		},
		async createAviz(data) {
			if (data.item.romaniaOrMoldova == 'ROMANIYA') {
				this.docId = data.item.id
				let hasAviz = false
				try {
					let response = await EmployeeSerive.hasAvizDocument(data.item.id)
					if (response.data) {
						hasAviz = true
					}
				} catch (e) {
					hasAviz = false
				}
				if (!hasAviz) {
					this.regNumberAviz = null;
					this.value = null
					let res = await EmployeeSerive.getEmployeeIfHaveLogin(data.item.toDepartmentId)
					this.options = res.data
					this.modalAviz = true
				} else {
					this.$router.push('/warehouse-management/transfers/view-aviz/' + data.item.id)
				}
			} else {
				this.$router.push('/warehouse-management/transfers/view-aviz-all/' + data.item.id)
			}
		},
		...mapActions('prices', [
			'getPricingAllList', 'getEditPricing', 'getPricesList',
			'getRegNumberItem', 'getDepartmentList', 'getPricingItemsWithPagination', 'getPricingItemsWithPaginationSection3'
		]),
		...mapActions('warehouse', [
			'getPendingIncomes', 'changeCurrentPackDocId', 'getPendingIncomesCount', 'resetExcelData'
		]),
		...mapActions('whIncomeModule', [
			'getPendingIncomes',
			'changeCurrentPackDocId',
			'getPendingIncomesCount',
			'getTCountOfDocsFromSale'
		]),
		async closeSidebar() {
			this.activeSidebar = false;
			this.editable = false;
			// this.activeEditSidebar = false;
			let paramsForSearch = {
				page: this.currentPage,
				limit: this.perPage
			};
			// await this.getPricingAllList(paramsForSearch);
		},
		async openSidebarPricing() {
			this.activeSidebar = true
			this.getDateCurrent();
			// this.getPricesList();
			await this.getRegNumberItem();
			this.getDepartmentsLocal();
			this.getDepartmentList();
		},
		getDepartmentsLocal() {
			return this.getDepartments
		},
		getDateCurrent() {
			this.currentDate = (new Date().toISOString().slice(0, 10));
		},
		removeForTransfer(id, customTabIndex) {
			WhDocument.remove(id).then(response => {
				setTimeout(() => {
					this.loadIncomes()
					// if (customTabIndex == 0) {
					// 	this.loadIncomes();
					// }
					// if (customTabIndex == 1) {
					// 	this.loadOldTransfer();
					// }
					// if (customTabIndex == 2) {
					// 	this.loadPendings();
					// }
				}, 200)
			})
		},
		removeForSpisat(id) {
			WhDocument.remove(id).then(response => {
				setTimeout(() => {
					this.loadIncomes()
					// if (customTabIndex == 0) {
					// 	this.loadIncomes();
					// }
					// if (customTabIndex == 1) {
					// 	this.loadOldTransfer();
					// }
					// if (customTabIndex == 2) {
					// 	this.loadPendings();
					// }
				}, 200)
			})
		},
		copyDoc(id) {
			this.copyDocId = id
			this.$store.commit('goods/setGoodsWithKeyword', []);
			this.$store.commit('warehouse/setListByProductsNotKirim', []);
			setTimeout(() => {
				this.sidebar.mode = 'create';
				this.sidebar.open = true
			}, 200)
		},
		openCreate(mode = 'create') {
			this.copyDocId = null
			this.$store.commit('goods/setGoodsWithKeyword', []);
			this.$store.commit('warehouse/setListByProductsNotKirim', []);
			setTimeout(() => {
				this.sidebar.mode = mode;
				this.sidebar.open = true
			}, 200)
		},
		lock($event) {
			setTimeout(() => {
				this.sidebar.close = $event
			}, 200)
		},
		async edit(item) {
			this.copyDocId = null
			this.items.forEach(i => {
				if (i._rowVariant)
					i._rowVariant = ''
			})
			item._rowVariant = 'primary'
			if (!item.currencyId) {
				item.currencyId = null;
			}
			if (item.contractId) {
				await ContractService.getContractById(item.contractId).then(res => {
					item.contract = res.data.contract
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
			this.editItem = Object.assign({}, item);
			this.openCreate('edit')
		},
		pricing(item) {

		},
		close() {
			// WhDocument.clearWhDocument(); //BU API O'ZGARDI
			this.resetExcelData();
			this.sidebar.open = false;
			this.sidebar.mode = 'create';
			this.editItem = Object.assign({}, initialForEditItem);
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		redirect($event) {
			this.close();
			setTimeout(() => {
				if (this.isTransfer) {
					this.$router.push(`/warehouse-management/transfers/view/${$event}`);
				} else {
					this.$router.push(`/warehouse-management/income/view/${$event}`);
				}
			}, 200);

		},
		loadPendings() {
			let newFilterSearch2 = {}

			newFilterSearch2.page = this.search.page
			newFilterSearch2.limit = this.search.limit
			WhDocument.pending(newFilterSearch2).then(response => {
				this.pending.items = response.data.items;
				this.total = response.data.total;
				this.pending.loaded = true;
				this.tabChanged = false;
			});
		},
		loadPrinyaty() {
			let newFilterSearch2 = {}

			newFilterSearch2.page = this.search.page
			newFilterSearch2.limit = this.search.limit
			if (Object.keys(this.filterSearch).length !== 0) {
				if (this.filterSearch.regDate.value !== '' && this.filterSearch.regDate.value !== null)
					newFilterSearch2.startDate = this.filterSearch.regDate.value
				if (this.filterSearch.regDate.value2 !== '' && this.filterSearch.regDate.value2 !== null)
					newFilterSearch2.endDate = this.filterSearch.regDate.value2

				if (this.filterSearch.department !== null) {
					let arr = [];
					arr.push(this.filterSearch.department.id);
					newFilterSearch2.fromDepartmentIds = arr;
				}

				if (this.filterSearch.toDepartment !== null) {
					let arr = [];
					arr.push(this.filterSearch.toDepartment.id);
					newFilterSearch2.toDepartmentIds = arr;
				}

				if (this.filterSearch.regNumber !== null && this.filterSearch.regNumber !== '')
					newFilterSearch2.regNumber = this.filterSearch.regNumber

			}
			WhDocument.searchTransferKirim(newFilterSearch2).then(response => {
				this.items = response.data.items;
				this.total = response.data.total;
				this.loader = false;
				this.tabChanged = false;
				this.search.attributes = [];
			}).catch((error) => {
				this.loader = false;
				this.tabChanged = false;
				const err = JSON.parse(error.request.response);
				this.$vs.notify({
					title: this.$t('words.error'),
					text: err.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			});
		},
		loadOldTransfer() {
			this.search.attributes = this.attributes;
			this.search.page = this.search.page
			WhDocument.search(this.search, "kochirish").then(response => {
				this.items = response.data.items;
				this.total = response.data.total;
				this.loader = false;
				this.tabChanged = false;
				this.search.attributes = [];
			}).catch((error) => {
				this.loader = false;
				this.tabChanged = false;
				const err = JSON.parse(error.request.response);
				this.$vs.notify({
					title: this.$t('words.error'),
					text: err.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			});
		},
		verifyList() {
			Verify.list().then(response => {
				this.tabChanged = false;
				this.pending.items = response;
			}).catch(e => {
				this.tabChanged = false;
			});
		},
		countPending() {
			WhDocument.pendingCount().then(response => {
				this.pending.total = response.data;
			})
			// if (this.isKirim) {
			// 	this.getPendingIncomesCount()
			// }
		},
		async changed($event, forWhat) {
			// this.tabChanged = true;
			this.activeTab = $event;
			if (this.search.page !== 1 && !forWhat) {
				this.search.page = 1;
				return 0;
			}
			await this.updateList(this.search.page, $event)
			if (forWhat == 'forPendingIncome') {
				this.setColumns();
				if ($event == 1) {
					// await this.getPendingIncomes();
					await this.$eventHub.$emit('fetchPendingIncomesFromSale');
				}
				return 0
			}
			if (forWhat == 'forIncome') {
				this.resetExcelData();
				this.loadIncomes();
				return 1;
			}
			if (forWhat == 'forTransfer') {
				this.customTabIndex = 0;
				if ($event == 0) {
					return
				}
			}
			if (!this.isFilterItemsExecuted) {
				await this.loadIncomes()
			}
			// if ($event === 0 && this.isTransfer) {
			// 	this.loadPrinyaty();
			// } else if ($event === 2 && this.isTransfer) {
			// 	this.loadPendings();
			// } else if ($event === 1 && this.isTransfer) {
			// 	this.loadOldTransfer();
			// } else if ($event === 1 && this.isOff) {
			// 	this.verifyList();
			// }
		},
		verify(id) {
			Verify.approve(id).then(response => {
				this.verifyList();
			})
		},
		async checkDocIdAndRedirect(packId, docId) {
			await this.changeCurrentPackDocId(docId);
			//this.$store.commit('warehosue/setCurrentPackDocId', docId);
			this.$router.push(`/warehouse-management/pendingIncome/edit/${packId}`);
		}
	},
	created() {
		this.countPending();
		if (this.isKirim) {
			this.getTCountOfDocsFromSale();
		}
		this.search.page = this.$route.query.page ? Number(this.$route.query.page) : 1
		this.activeTab = this.$route.query.tab ? Number(this.$route.query.tab) : 0
		this.customTabIndex = this.$route.query.tab ? Number(this.$route.query.tab) : 0
		this.changed(this.customTabIndex, 1)
	},
	computed: {
		tabName() {
			if (this.activeTab == 0) {
				return 'suspend'
			} else if (this.activeTab == 1) {
				return 'waiting'
			} else if (this.activeTab == 2) {
				return 'received'
			} else if (this.activeTab == 3) {
				return 'sended'
			} else if (this.activeTab == 4) {
				return 'pending'
			}
		},
		name() {
			if (this.value) {
				return this.value.firstName.charAt(0)
			}
		},
		...mapState(['isAdmin']),
		...mapState('whIncomeModule', [
			'pendingIncomePackages',
			'totalPendingPackages',
			'pendingPacksCount',
			'tCountOfDocsFromSale'
		]),
		...mapState('warehouse',
			['pendingIncomePackages', 'totalPendingPackages', 'pendingPacksCount']
		),
		...mapGetters('prices', [
			'getPricing', 'getEditItems', 'getDepartments', 'getRegNumber'
		]),
		sectionName() {
			return this.section.toUpperCase();
		},
		isTabChanged() {
			return this.tabChanged;
		}
	},
	watch: {
		'toggle.filter': {
			async handler(newVal) {
				if (!newVal) {
					await this.$refs.filterRef.clearParams()
				}
			}
		},
		value: {
			async handler(newVal) {
				let res = await EmployeeSerive.getRegNumber(newVal.id)
				if (res.data <= 9) {
					this.regNumberAviz = '000' + res.data
				} else if (res.data <= 99 && res.data > 9) {
					this.regNumberAviz = '00' + res.data
				} else {
					this.regNumberAviz = '0' + res.data
				}
			}
		}
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
a {
	color: black !important;
}
.no-wrap {
	white-space: nowrap;
}
.poin{
	cursor: pointer;
}
.table-wrapper {
	position: relative;
	padding: 5px;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}
</style>
